import { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { formatLocalDateTime } from "@/utils/utils";
import { useGlobalModel } from "@/model/globalModel";
import { contractDataModel } from "./contractDataModel";
import { ContractResult } from "@/views/contract/manage/ContractManageTypes";

export function ContractDataTable() {

    const { getDictNodeName } = useGlobalModel();
    const {
        loading, dataSource, pgCfg, selectedRowKeys, selectedData,
        loadData, onSearch, setSelectedRowKeys, setSelectedData
    } = contractDataModel();

    const columns: ColumnsType<ContractResult> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '合约单号',
            dataIndex: 'code',
            align: "center",
            width: 140,
        },
        {
            title: '账户编码',
            dataIndex: 'accountCode',
            align: "center",
            width: 140,
            ellipsis: true,
        },
        {
            title: '账户类型',
            dataIndex: 'accountTypeName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '签约类型',
            dataIndex: 'contractType',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (text) => text === null || text === '' ? "暂无" : getDictNodeName(text)
        },
        {
            title: '账户实体',
            dataIndex: 'beName',
            align: "center",
            width: 200,
        },
        {
            title: '合约起止日期',
            dataIndex: 'startTime',
            align: "center",
            width: 160,
            render: (text, record) =>
                formatLocalDateTime(record.startTime).replaceAll("-", "/").substring(0, 10)
                + "-"
                + formatLocalDateTime(record.endTime).replaceAll("-", "/").substring(0, 10)
        },
        {
            title: '签约额度',
            dataIndex: 'contractAmount',
            align: "center",
            width: 80,
            ellipsis: true,
        },
        {
            title: '关联对账单',
            dataIndex: 'soaCount',
            align: "center",
            width: 80,
        },
        {
            title: '关联账单',
            dataIndex: 'billCount',
            align: "center",
            width: 80,
        },
        {
            title: '申请人',
            dataIndex: 'createUser',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '申请时间',
            dataIndex: 'createTime',
            align: "center",
            width: 140,
            render: (text) => formatLocalDateTime(text)
        },
        {
            title: '审核人',
            dataIndex: 'approver',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '审核时间',
            dataIndex: 'approvalTime',
            align: "center",
            width: 140,
            render: (text) => formatLocalDateTime(text)
        }
    ];

    useEffect(() => {
        onSearch();
    }, [])

    const onRow = (record: ContractResult, selected: boolean) => {
        let arr = [];
        let list = [];
        if (selected) {
            arr = Array.from(new Set([...selectedRowKeys, record.id]));
            list = Array.from(new Set([...selectedData, record]));
        } else {
            arr = selectedRowKeys.filter(item => { return item !== record.id });
            list = selectedData.filter(item => item.id !== record.id)
        }
        setSelectedRowKeys(arr);
        setSelectedData(list);
    };

    const onSelectAll = (selected: boolean, changeRows: ContractResult[]) => {
        if (selected) {
            let addSelected = [];
            let addRows = [];
            for (const item of changeRows) {
                addSelected.push(item.id);
                addRows.push(item);
            }
            setSelectedRowKeys([...addSelected, ...selectedRowKeys]);
            setSelectedData([...addRows, ...selectedData]);
        } else {
            setSelectedRowKeys(selectedRowKeys.filter((id) => {
                return !changeRows.some((item) => item.id === id)
            }));
            setSelectedData(selectedData.filter((data) => {
                return !changeRows.some((item) => item.id === data.id)
            }));
        }
    }

    return (
        <Table
            loading={loading}
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataSource}
            rowSelection={{
                selectedRowKeys: selectedRowKeys,
                onSelectAll: (selected, selectedRows, changeRows) => onSelectAll(selected, changeRows),
                onSelect: (record, selected, selectedRows) => onRow(record, selected),
            }}
            onRow={record => {
                return {
                    onClick: event => onRow(record, !selectedRowKeys.includes(record.id))
                };
            }}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: '2200px', y: "calc(100vh - 446px)" }}
        />
    )
}

